import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-2 mt-2 lg:mt-0 rounded shadow bg-white" }
const _hoisted_2 = { class: "p-6" }
const _hoisted_3 = { class: "text-xl font-bold" }
const _hoisted_4 = {
  key: 0,
  class: "pt-2 text-gray-600 text-xs lg:text-sm flex items-center justify-center lg:justify-start"
}
const _hoisted_5 = { class: "pt-2 text-gray-600 text-xs lg:text-sm flex items-center justify-center lg:justify-start" }
const _hoisted_6 = { class: "flex justify-start items-start my-4" }
const _hoisted_7 = {
  key: 0,
  class: "p-2 mt-2 rounded shadow bg-white"
}
const _hoisted_8 = { class: "p-6 center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "p-2 mt-2 rounded shadow bg-white"
}
const _hoisted_12 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " お客様名 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " Eメール "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 日付 ")
  ])
], -1)
const _hoisted_14 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_15 = { class: "px-6 py-4 text-gray-500 whitespace-nowrap" }
const _hoisted_16 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_17 = { class: "px-6 py-4 text-xs text-gray-500 whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.trial.title), 1),
        (_ctx.trial.publish_from || _ctx.trial.publish_to)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              _createElementVNode("span", null, [
                _createVNode(_component_fa, {
                  icon: "calendar",
                  class: "text-sm text-color-3 mr-2"
                })
              ]),
              _createTextVNode(" " + _toDisplayString(`${
            _ctx.trial.publish_from
              ? _ctx.formatDate(_ctx.trial.publish_from, "YYYY-MM-DD")
              : "-"
          } ~ ${
            _ctx.trial.publish_to ? _ctx.formatDate(_ctx.trial.publish_to, "YYYY-MM-DD") : "-"
          }`), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("span", null, [
            _createVNode(_component_fa, {
              icon: "eye",
              class: "text-sm text-color-3 mr-2"
            })
          ]),
          _createTextVNode(" " + _toDisplayString(`${_ctx.trial.view_count} / ${_ctx.trial.click_count}`), 1)
        ])
      ])
    ]),
    _createElementVNode("ul", _hoisted_6, [
      _createElementVNode("li", {
        class: _normalizeClass(["cursor-pointer py-2 px-4 text-gray-500 border-b-8 border-gray-500 w-1/2 text-center mx-1", _ctx.selected_tab === 'contents' ? 'text-color-3 border-color-3' : '']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selected_tab = 'contents')),
        "x-text": "tab"
      }, " 詳細 ", 2),
      _createElementVNode("li", {
        class: _normalizeClass(["cursor-pointer py-2 px-4 text-gray-500 border-b-8 border-gray-500 w-1/2 text-center mx-1", _ctx.selected_tab === 'history' ? 'text-color-3 border-color-3' : '']),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected_tab = 'history')),
        "x-text": "tab"
      }, " 申込履歴 ", 2)
    ]),
    (_ctx.selected_tab == 'contents')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: _ctx.trial.main_image_url,
              width: "240"
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", {
            innerHTML: _ctx.trial.body
          }, null, 8, _hoisted_10)
        ]))
      : _createCommentVNode("", true),
    (_ctx.selected_tab == 'history')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("tbody", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applyments, (applyment) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: applyment.id
                }, [
                  _createElementVNode("td", _hoisted_15, _toDisplayString(applyment.customer_name), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(applyment.customer_email), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.formatDate(applyment.created_at, "YYYY-MM-DD")), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}